module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Bussigny_VD-f98abbc1c7931af5c32d64d24c33763b.svg";